// extracted by mini-css-extract-plugin
module.exports = {"root":"_3K_1q","gem":"_1F45J"};